<div class="main-container lg-view">
	<h3>Job forms</h3>

	<ng-container *ngIf="formTemplates?.length">
		<ng-container>
			<div class="job-form-container" *ngFor="let item of formTemplates">
				<button mat-flat-button type="button"
					[class.selected]="selectedFormTemplate?.formTemplateId === item.formTemplateId"
					(click)="selectedFormTemplate = item; formsModal.open()"
					[disabled]="formsBeingSaved[item.formTemplateId]">

					<div class="form-button-details">
						<span class="name">{{ item.formName }}</span>

						<app-loader [isInline]="true" *ngIf="formsBeingSaved[item.formTemplateId]"></app-loader>

						<span class="details" *ngIf="item.collectedOn && item.collectedBy && !formsBeingSaved[item.formTemplateId]">Collected on {{
							moment.parseZone(item.collectedOn).format('MM/DD/YYYY') }} by {{ item.collectedBy }}</span>
						<span class="details" *ngIf="!formsBeingSaved[item.formTemplateId] && !(item.collectedOn && item.collectedBy)">Not collected</span>
					</div>
				</button>
			</div>
		</ng-container>
	</ng-container>

	<div class="empty-message-container" *ngIf="!formTemplates?.length">There are no forms!</div>
</div>

<div class="actions-container md-view">
	<ng-container
		*ngIf="!(customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
	</ng-container>

	<div class="actions-placeholder-message"
		*ngIf="(customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>
</div>

<generic-modal #formsModal>

	<ng-template #modalBody>
		 <form-viewer *ngIf="selectedFormTemplate" [formTemplate]="selectedFormTemplate"
			(afterLoading)="currentFormViewer = $event" [submitFormCallback]="onSubmit.bind(self)" [isReadOnly]="false"></form-viewer>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="currentFormViewer.submit();">Submit</button>
		<button mat-flat-button (click)="resetSelection();">Cancel</button>
	</ng-template>
</generic-modal>